var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_11942)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.858,
    fill: "#FF5502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4241 32.9545H24.4639V18.6515C25.5721 17.6497 27.0073 17.0454 28.5752 17.0454C32.0449 17.0454 34.865 20.0049 34.928 23.681C35.3959 23.5049 35.8995 23.409 36.4241 23.409C38.9011 23.409 40.9091 25.5459 40.9091 28.1818C40.9091 30.8177 38.9011 32.9545 36.4241 32.9545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3767 19.938H21.9156V32.9545H23.3767V19.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9935 21.3843H20.4546V32.9545H18.9935V21.3843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5325 24.2768H16.0715V32.9545H17.5325V24.2768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1494 22.8305H14.6104V32.9545H13.1494V22.8305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6883 25.7231H10.2273V32.9545H11.6883V25.7231Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_11942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/Soundcloud.6a98e714e8c08edc68a742f2e886df72.svg";
export { ForwardRef as ReactComponent };